import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router"
import AdminService from "@/services/AdminService";
import {useMainStore} from "@/stores/mainStore";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/login",
        name: "login",
        component: () => import(/* webpackChunkName: "login" */ "../views/LoginView.vue"),
        meta: {
            guest: true
        }
    },
    {
        path: "/",
        name: "home",
        component: () => import(/* webpackChunkName: "home" */ "../views/HomeView.vue"),
        meta: {
            auth: true
        }
    },
    {
        path: "/config",
        name: "config",
        component: () => import(/* webpackChunkName: "config" */ "../views/ConfigView.vue"),
        meta: {
            auth: true,
            config: true
        }
    },
    {
        path: "/report",
        name: "report",
        component: () => import(/* webpackChunkName: "report" */ "../views/ReportView.vue"),
        meta: {
            auth: true,
            report: true
        }
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from, next) => {
    const token = sessionStorage.getItem("access-token");
    if (to.matched.some(record => record.meta.auth)) {
        try {
            const response = await AdminService.checkToken(token);
            useMainStore().user = response.user;
            if (to.matched.some(record => record.meta.config) && !response.user.portalConfig) {
                next("/");
            } else if (to.matched.some(record => record.meta.report) && !response.user.portalReport) {
                next("/");
            } else {
                next();
            }
        } catch (error) {
            sessionStorage.removeItem("access-token");
            next("/login");
        }
    } else if (to.matched.some(record => record.meta.guest)) {
        if (token !== null) {
            next("/")
        } else {
            next();
        }
    } else {
        next();
    }
});

export default router;
